<script>
    export let title;
    export let path;
    export let PreviousPage;
</script>

<div class="page-breadcrumb">
    <div class="row">
        <div class="col-6">
            <h4 class="page-title">{title}</h4>
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <a href="/{path}">{PreviousPage}</a>
                    </li>
                    <li
                        class="breadcrumb-item active"
                        aria-current="page">
                        {title}
                    </li>
                </ol>
            </nav>
        </div>
        <div class="col-6">
            <div class="text-right">
                <small>Total Arts Done</small>
                <h5 class="text-info">56</h5>
            </div>
        </div>
    </div>
</div>